<template>
  <b-modal id="optionsModal"
    size=lg
    body-bg-variant="light"
    hide-backdrop
    content-class="shadow"
    @hidden="emitCloseOptionsModal"
  >
    <template #modal-title width="90%">
      <b-row v-if="current_item.image_path">
        <b-col cols="9" class="pt-1">{{ current_item.name }}</b-col>
        <b-col><b-img style="float: right;" rounded="circle" width="50" :src="current_item.image_path" :alt="current_item.name"></b-img></b-col>
      </b-row>
      <b-row v-else>
        <b-col class="pt-1">{{ current_item.name }}</b-col>
      </b-row>
    </template>
    <div role="tablist">
      <b-card v-for="(option, index) in optionsMenu" :key="option.id" no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button v-if="option.add_price > 0" block v-b-toggle="'accordion-' + option.id" variant="light">{{option.name}} - {{option.add_price | toCurrency}}</b-button>
          <b-button v-else block v-b-toggle="'accordion-' + option.id" variant="light">{{option.name}}</b-button>
          <b-alert v-if="invalidMultiSelect && optState[index]==false" show variant="primary">You have selected too many options!</b-alert>
        </b-card-header>
        <b-collapse :id="'accordion-' + option.id" visible accordion="option-accordion" role="tabpanel">
          <b-card-body label="Make your selection">

            <b-form-textarea v-if="option.select_qty=='Notes'" id="line-notes" rows="2" v-model="new_line_notes" placeholder="Notes, allergies, etc"></b-form-textarea>

            <div v-else-if="option.select_qty=='GiftCard'">
              <b-row>
                <b-col>
                  <b-form-input id="card-number" v-model="gcCardNumber" placeholder="Card Number"></b-form-input>
                  <b-form-text id="card-number-help">Enter your card number. Leave blank if you don't have one</b-form-text>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input id="top-up-amount" v-model="gcTopUpAmount" type="number" step="0.01" placeholder="$0.00"></b-form-input>
                  <b-form-text id="top-up-amount-help">How much do you want to add to the card?</b-form-text>
                </b-col>
              </b-row>
            </div>

            <b-form-group v-else-if="option.select_qty==1">
              <b-form-radio-group
                v-model="option_select[index]"
                :options="option.optionitems"
                value-field="id"
                text-field="name_price"
                stacked
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group v-else>
              <b-form-checkbox-group
                v-model="option_select[index]"
                :options="option.optionitems"
                value-field="id"
                text-field="name_price"
                switches
                stacked
                :state="optState[index]"
                @input="limitMultiSelect(index, option.select_qty)"
              ></b-form-checkbox-group>
            </b-form-group>

          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <template v-if="!edititem" v-slot:modal-footer="{ cancel, ok }">
      <b-button variant="light" @click="cancel()">Back</b-button>
      <b-button id="addOptions" variant="outline-dark" @click="ok(); addOrderLineToDB(current_item);">Add</b-button>
    </template>
    <template v-else v-slot:modal-footer="{ cancel, ok }">
      <b-button variant="outline-dark" @click="cancel()">Back</b-button>
      <b-button id="updateOptions" variant="light" @click="ok(); emitRemoveOldItem(); addOrderLineToDB(current_item)">Update</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'Options',
  props: ['current_item', 'option_select', 'edititem', 'line_notes'],
  data () {
    return {
      new_line_notes: '',
      optState: [],
      gcCardNumber: this.current_item.gcCardNumber,
      gcTopUpAmount: this.current_item.gcTopUpAmount
    }
  },

  computed: {
    invalidMultiSelect: function() {
      if (this.option_select) {
        return this.optState.includes(false) ? true : false;
      } else {
        return false;
      }
    },

    optionsMenu: function() {
      var optionarr = [];
      const linenotesobj = {
        'id': 9999999,
        'name': 'Notes / Allergies, etc.',
        'select_qty': 'Notes',
        'name_price': 'Notes',
        'sort_order': 999
      }
      const giftcardobj = {
        'id': 9999997,
        'name': 'Loyalty / Gift Card',
        'select_qty': 'GiftCard',
        'name_price': 'GiftCard',
        'sort_order': 0
      }
      optionarr = optionarr.concat(this.current_item.options);
      if (this.current_item.is_giftcard) {
        optionarr.push(giftcardobj)
      }
      optionarr.push(linenotesobj);
      return optionarr;
      // return this.current_item.options;
    },

    optionNotes: {
      get: function() {
        return this.line_notes ? this.line_notes : '';
      },
      set: function(newVal) {
        this.new_line_notes = newVal ? newVal : this.line_notes;
        // return newVal;
      }
    },
  },

  methods: {
    emitCloseOptionsModal() {
      this.$emit('emit-close-options-modal');
    },

    // adjusttype = 'remove' - Remove one from the quantity, remove item if qty = 1
    emitRemoveOldItem() {
      this.$emit('emit-remove-old-item');
    },

    limitMultiSelect(i, max_select) {
      // get element of button to enable / disable
      const btn = (this.edititem) ? document.getElementById("updateOptions") : document.getElementById("addOptions");
      // If number of selected items reaches the maximum allowed for that option "header"
      if (this.option_select[i].length <= max_select || max_select==0) {
        this.optState[i] = null;
        btn.disabled = false;
      } else {
        this.optState[i] = false;
        btn.disabled = true;
      }
    },

    // build item structure before adding to db
    buildLineDetails(item) {
      // set option_select as the gcCardNumber & gcTopUpAmount if it's a GiftCard
      if (item.is_giftcard) {
          this.option_select[0] = this.gcCardNumber
          this.option_select[1] = this.gcTopUpAmount
      }
      // flatten out the option select array to get an array of selected optionitem ids
      var choicearray = [].concat.apply([], this.option_select);
      // sort them so they can be consistently queried
      choicearray.sort((a, b) => a - b);
      // build into a string of ids to use as a key in the indexedDB (arrays not accepted)
      var choicestring = choicearray.join('');

      // build new array to hold selected options only - called choiceitems
      var choices = item.options;
      for (let i in choices) {
        const chc = choices[i].optionitems.filter(optitem => choicearray.indexOf(optitem.id) >= 0);
        choices[i]['choiceitems'] = chc;
      }

      let item_id = item.id ? item.id : item.item_id;
      let notes = this.new_line_notes ? this.new_line_notes : '' ;
      let gcCardNumber = this.gcCardNumber ? this.gcCardNumber : '' ;
      let gcTopUpAmount = this.gcTopUpAmount ? Number(this.gcTopUpAmount) : 0 ;
      var linedetails = {
          item_id: item_id,
          name: item.name,
          std_price: Number(item.std_price),
          description: item.description,
          image_path: item.image_path,
          is_giftcard: item.is_giftcard,
          gcCardNumber: gcCardNumber,
          gcTopUpAmount: gcTopUpAmount,
          qty: 1,
          notes: notes,
          options: choices,
          choicearray: choicearray,
          choicestring: choicestring,
          option_select: this.option_select
      }
      return linedetails;
    },

    addOrderLineToDB(item) {
      var linedetails = this.buildLineDetails(item);
      // open db
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");

        // read from DB to see if there are any items with same id
        const getRequest = orderStore.get([linedetails.item_id, linedetails.choicestring, linedetails.notes]);
        getRequest.onsuccess = () => {
          // if item exists, update qty
          if (getRequest.result) {
            var newqty = getRequest.result.qty+1;
            // this.updateOrderInDB(linedetails, curr_qty+1);
            orderStore.put({
              item_id: linedetails.item_id,
              name: linedetails.name,
              std_price: Number(linedetails.std_price),
              description: linedetails.description,
              image_path: linedetails.image_path,
              is_giftcard: linedetails.is_giftcard,
              gcCardNumber: linedetails.gcCardNumber,
              gcTopUpAmount: linedetails.gcTopUpAmount,
              qty: newqty,
              notes: linedetails.notes,
              options: linedetails.options,
              choicearray: linedetails.choicearray,
              choicestring: linedetails.choicestring,
              option_select: linedetails.option_select
            });
            // else add the item
          } else {
            // add item
            orderStore.add(linedetails);
          }
          transaction.oncomplete = () => {
            // close db connection
            db.close();
          };
        };
      };
    },

    async showOptionsOrAddItem() {
      if (this.current_item.options.length==0 && this.edititem==false && this.current_item.is_giftcard==false) {
        await this.addOrderLineToDB(this.current_item);
        this.emitCloseOptionsModal();
      } else {
        this.$bvModal.show('optionsModal');
      }
    }

  },

  mounted() {
    this.new_line_notes = this.line_notes;
    this.showOptionsOrAddItem();
  }
}
</script>
<style>

  /* .custom-control-input.is-valid ~ .custom-control-label {
    color: black !important;
  }

  .custom-control-input.is-valid > checkbox {
    color: black !important;
  } */

  #optionsModal___BV_modal_outer_ {
    z-index: 1240 !important;
  }

  @media (min-width: 1200px) {
    #optionsModal {
      padding-right: 320px;
    }
  }

</style>
